<template>
    <div class="d-flex align-center">
        <router-link 
            :to="{name: 'event-by-id', params: {id: $route.params.id}}" 
            :class="{'event-navbar__link ml-6': true, 'event-navbar__link-active': $route.name === 'event-by-id'}"
        >
            General
        </router-link>
        <router-link 
            :to="{name: 'agenda-events', params: {id: $route.params.id}}" 
            :class="{'event-navbar__link ml-6': true, 'event-navbar__link-active': $route.name === 'agenda-events'}"
        >
            Agenda
        </router-link>
        <router-link 
            :to="{name: 'my-agenda-events', params: {id: $route.params.id}}"  
            :class="{'event-navbar__link ml-6': true, 'event-navbar__link-active': $route.name === 'my-agenda-events'}"
        >
            My Agenda
        </router-link>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss">
.event-navbar__link {
    font-size: 14px;
    font-weight: 700;
    font-family: Montserrat, sans-serif;
    line-height: 17.07px;
    color: #9B9B9B !important;

    &-active {
        color: var(--button-secondary-background-color) !important;
    }
}
</style>